<template>
    <v-row no-gutters>
        <v-col cols="12" sm="1"></v-col>
        <v-col cols="12" sm="10">
            <div class="container-whistleblowing">
                <keep-alive :include="aliveInclude">
                    <whistleblowing-contract v-if="$store.state.step===1" @done="goNext()" />
                    <whistleblowing-content v-if="$store.state.step===2" @done="goBack()" />
                </keep-alive>
            </div>
        </v-col>
        <v-col cols="12" sm="1"></v-col>
    </v-row>
</template>

<script>
    import WhistleblowingContract from "../components/WhistleblowingContract";
    import WhistleblowingContent from "../components/WhistleblowingContent";
    import store from "@/store";

    export default {
        name: "Index",
        components: {
            WhistleblowingContract,
            WhistleblowingContent,
        },
        data() {
            return {
                flowSteps: [
                    { step: 1, componentName: "whistleblowingContract" },
                    { step: 2, componentName: "whistleblowingContent" },
                ],
            };
        },

        created() {
            let locale = "zh_TW";
            if (this.$route.query !=='' && this.$route.query.lang === 'CN') {
                locale = 'zh_CH';
            }
            if (this.$route.query !=='' && this.$route.query.lang === 'US') {
                locale = 'en_US';
            }
            this.setLocale(locale);
        },

        computed: {
            aliveInclude() {
                let cachedSteps = this.flowSteps.filter((flowStep) => flowStep.step <= store.state.step);
                return cachedSteps.map((flowStep) => flowStep.componentName);
            },
        },

        methods: {
            goNext() {
                store.commit("goNext");
            },
            goBack() {
                store.commit("goBack");
            },
            setLocale(locale) {
                this.$i18n.changeLocale = locale;
            },
            getLocale() {
                return this.$i18n.changeLocale;
            }
        },
    };
</script>

<style>
    .container-whistleblowing {
        margin: 20px;
    }
</style>
